(function () {
    'use strict';

    angular.module("imApp").factory("tailorAccessMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getTailorAccessMenu: function (parms) {
                return $ihttp.post({
                    method: 2095,
                    parameters: parms || {}
                });
            },
            listTailorAccessDatas: function (parms) {
                return $ihttp.post({
                    method: 2100,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
